import {AfterViewInit, Directive, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';

import {PropertyFilterGroup} from '../model/property-type-group.model';
import {FilterPanel} from '../model/filter-panel.model';
import {FilterPanelHandler} from '../model/filter-panel-handler.model';
import {HomeSearchFiltersAnalyticsHandler} from '../home-search-filters-analytics-handler';
import { flatten, uniqPrimitiveValues } from 'src/app/core/helpers/array.healper';


@Directive()
export class CheckboxListFilter implements OnInit, AfterViewInit {

  @ViewChild('clearTemplate') clearTemplate: TemplateRef<any>;

  @Input() panel: FilterPanel;
  @Input() value: string[] = [];
  @Output() valueChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() cleanValue: EventEmitter<string[]> = new EventEmitter<string[]>();

  filters: PropertyFilterGroup[] = [];

  formArray: FormArray;
  form: FormGroup;

  originalPanelName = '';
  panelHandler: FilterPanelHandler;

  constructor(protected fb: FormBuilder,
              private googleAnalyticsEventManager: HomeSearchFiltersAnalyticsHandler) {
  }

  ngOnInit() {
    this.panelHandler = new FilterPanelHandler(this.panel);
    this.originalPanelName = this.panel.name;

    this.formArray = new FormArray([]);

    this.filters.forEach((filter) => {
      const control = new FormControl();
      const values = this.value.filter(v => filter.options.some(o => o.value === v));
      control.setValue(values);
      this.formArray.push(control);
    });

    this.form = this.fb.group({
      items: this.formArray,
    });
  }

  ngAfterViewInit() {
    // ChangeDetectorRef não funciona mais? por isso tem 35% de rejeição na comunidade de devs
    setTimeout(() => {
      this.panelHandler.setPanelExtraTemplate(this.clearTemplate);
      this.setPanelHeader();
    }, 0);
  }

  cleanFilter(evt: MouseEvent) {
    evt.stopPropagation();
    this.formArray.reset([...new Array(this.formArray.length)].map(() => []));
    this.setValue();
    this.cleanValue.emit(this.value);
    this.valueChange.emit(this.value);
  }

  emit() {
    this.setValue();
    this.valueChange.emit(this.value);
  }

  setValue() {
    this.value = uniqPrimitiveValues(
      flatten(this.formArray.getRawValue())
    );

    this.setPanelHeader();
  }

  setPanelHeader() {
    this.panelHandler.setPanelHeader(
      this.value.length
        ? `${this.originalPanelName} (${this.value.length})`
        : this.originalPanelName
    );
  }

  sendEvent($event: any) {
    const eventLabel = `${this.panel.groupingName}:${$event.groupName.toLowerCase()}:${$event.item.value}`;
    this.googleAnalyticsEventManager.sendEvent(eventLabel);
  }

  sendEventWhenSelectingAll(groupName) {
    const eventLabel = `${this.panel.groupingName}:${groupName.toLowerCase()}:selecionou-todos`;
    this.googleAnalyticsEventManager.sendEvent(eventLabel);
  }

}
